module.exports = __webpack_public_path__ + "img/tu6.18fe0950.png";